module.exports = __webpack_public_path__ + "img/r1.c2c8df95.png";